export const SHOW_SETTINGS = 'SHOW_SETTINGS'
export const HIDE_SETTINGS = 'HIDE_SETTINGS'

export const PROFILE_DATA_REQUEST = 'PROFILE_DATA_REQUEST'
export const PROFILE_DATA_SUCCESS = 'PROFILE_DATA_SUCCESS'
export const PROFILE_DATA_FAILURE = 'PROFILE_DATA_FAILURE'

export const UPDATE_NAME_REQUEST = 'UPDATE_NAME_REQUEST'
export const UPDATE_NAME_SUCCESS = 'UPDATE_NAME_SUCCESS'
export const UPDATE_NAME_FAILURE = 'UPDATE_NAME_FAILURE'

export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST'
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS'
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE'

export const UPDATE_AVATAR_REQUEST = 'UPDATE_AVATAR_REQUEST'
export const UPDATE_AVATAR_SUCCESS = 'UPDATE_AVATAR_SUCCESS'
export const UPDATE_AVATAR_FAILURE = 'UPDATE_AVATAR_FAILURE'

export const RESET_PROFILE_UPDATED_STATE = 'RESET_PROFILE_UPDATED_STATE'
